/* In motion (sections/shoreline-motion.liquid).

   Deals the tiles into staggered columns (two on phones, three wider) and,
   as the page scrolls, drifts each column at its own speed; pop-up clips
   rise behind the tiles, fill the screen and leave (popTo). Clips load as
   they near the screen and play only while on it; the pause button holds a
   clip still until pressed again. With reduced motion nothing drifts or
   plays: the posters show.

   Like the photo hero: one update per frame, measured once per size, and a
   style is written only when its value changes. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia && window.matchMedia('(max-width: 749px)');
  // Drift per column, as a share of the distance from the screen's middle.
  var SPEEDS = { 2: [0.04, -0.1], 3: [0.05, -0.09, 0.12] };

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function Motion(root) {
    this.root = root;
    this.field = root.querySelector('[data-sl-mo-field]');
    this.tiles = all(root, '[data-sl-mo-tile]');
    this.cols = [];
    this.count = 0;
    this.pops = reduced ? [] : all(root, '[data-sl-mo-pop]').map(function (el) {
      return { el: el, card: el.firstElementChild, vid: el.querySelector('video') };
    });
    this.deal();
    this.bindVideos();
    if (!reduced) this.bindDrift();
  }

  function easeOut(x) { return 1 - Math.pow(1 - x, 3); }
  function easeIn(x) { return x * x * x; }

  // Pop-ups share the stretch where the section fills the screen: each
  // rises from below as a half-size card, fills the screen, holds, then
  // shrinks away off the top. q runs 0 to 1 over that stretch.
  Motion.prototype.popTo = function (q) {
    var n = this.pops.length;
    var phone = narrow && narrow.matches;
    this.pops.forEach(function (p, k) {
      var a = 0.02 + (0.96 * k) / n;
      var b = 0.02 + (0.96 * (k + 1)) / n;
      var t = (q - a) / (b - a);
      if (t > -0.4 && p.vid && !p.vid.getAttribute('src')) {
        p.vid.preload = 'auto';
        p.vid.src = p.vid.getAttribute('data-src');
      }
      var on = t > 0 && t < 1;
      if (on !== p.on) {
        p.on = on;
        p.el.classList.toggle('is-on', on);
        if (p.vid) {
          if (on) { var go = p.vid.play(); if (go && go.catch) go.catch(function () {}); }
          else p.vid.pause();
        }
      }
      if (!on) return;
      var y, s;
      if (t < 0.42) { var e = easeOut(t / 0.42); y = 80 * (1 - e); s = 0.5 + 0.5 * e; }
      else if (t < 0.58) { y = 0; s = 1; }
      else { var f = easeIn((t - 0.58) / 0.42); y = -80 * f; s = 1 - 0.5 * f; }
      var tf = 'translate3d(0,' + y.toFixed(2) + '%,0) scale(' + s.toFixed(4) + ')';
      if (p.tf !== tf) { p.tf = tf; p.card.style.transform = tf; }
      // Phones: corners round off as the card shrinks, square when it fills.
      if (phone) {
        var r = Math.round(((1 - s) / 0.5) * 36) + 'px';
        if (p.r !== r) { p.r = r; p.card.style.borderRadius = r; }
      } else if (p.r) { p.r = null; p.card.style.borderRadius = ''; }
    });
  };

  // Tile i goes to column i mod n, so the order still reads across.
  Motion.prototype.deal = function () {
    var n = narrow && narrow.matches ? 2 : 3;
    if (this.tiles.length < 3) n = Math.max(1, Math.min(n, this.tiles.length));
    if (n === this.count) return;
    this.count = n;
    var field = this.field;
    this.cols.forEach(function (c) { field.removeChild(c); });
    this.cols = [];
    for (var c = 0; c < n; c++) {
      var col = document.createElement('div');
      col.className = 'sl-mo__col';
      this.cols.push(col);
      field.appendChild(col);
    }
    var cols = this.cols;
    this.tiles.forEach(function (t, i) { cols[i % n].appendChild(t); });
    field.classList.add('is-dealt');
    this.speeds = SPEEDS[n] || [0, 0, 0];
    this.cols.forEach(function (col) { col.__y = null; });
    this.last = null;
  };

  Motion.prototype.bindDrift = function () {
    var self = this;
    var ask = function () { self.frame(); };
    document.addEventListener('scroll', ask, { passive: true, capture: true });
    window.addEventListener('resize', function () { self.deal(); self.frame(); }, { passive: true });
    this.frame();
  };

  Motion.prototype.frame = function () {
    if (this.queued) return;
    this.queued = true;
    var self = this;
    requestAnimationFrame(function () {
      self.queued = false;
      var rect = self.root.getBoundingClientRect();
      var vh = window.innerHeight;
      if (self.pops.length) {
        var span = rect.height - vh;
        self.popTo(span > 0 ? -rect.top / span : -1);
      }
      if (rect.bottom < -vh * 0.5 || rect.top > vh * 1.5) return;
      // Distance of the section's middle from the screen's middle.
      var off = Math.round(rect.top + rect.height / 2 - vh / 2);
      if (off === self.last) return;
      self.last = off;
      self.cols.forEach(function (col, k) {
        var y = Math.round(off * self.speeds[k]);
        if (col.__y === y) return;
        col.__y = y;
        col.style.transform = 'translate3d(0,' + y + 'px,0)';
      });
    });
  };

  Motion.prototype.bindVideos = function () {
    var vids = all(this.root, '.sl-mo__field video[data-src]'); // pop-ups play from popTo
    if (!vids.length) return;
    all(this.root, '[data-sl-mo-pause]').forEach(function (btn) {
      var v = btn.parentNode.querySelector('video');
      if (!v) return;
      btn.addEventListener('click', function () {
        v.__held = !v.__held;
        btn.setAttribute('aria-pressed', v.__held ? 'true' : 'false');
        btn.setAttribute('aria-label', v.__held ? 'Play video' : 'Pause video');
        if (v.__held) v.pause();
        else if (v.__seen) play(v);
      });
    });
    if (reduced || !('IntersectionObserver' in window)) return;

    function play(v) {
      if (!v.getAttribute('src')) v.src = v.getAttribute('data-src');
      var go = v.play();
      if (go && go.catch) go.catch(function () {});
    }
    // Fetch a little before the clip arrives, so it is ready to play.
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var v = e.target;
        if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = v.getAttribute('data-src'); }
        near.unobserve(v);
      });
    }, { rootMargin: '300px 0px' });
    // Play while at least a fifth of it is on screen.
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.__seen = e.isIntersecting;
        if (e.isIntersecting && !v.__held) play(v);
        else v.pause();
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { near.observe(v); seen.observe(v); });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-sl-mo]').forEach(function (root) {
      if (!root.__mo) root.__mo = new Motion(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
